const ALLOWED_AGENT_IMAGE_HOSTNAMES = [
  'agent-images-production.expproptech.com',
  'agent-images-staging.expproptech.com',
  'images.expcloud.com',
] as const;

export const DEFAULT_AGENT_PROFILE_PIC_PATH =
  '/next/assets/images/agent-search/agent-default-profile-pic.png';

export function isAllowedImageDomain(url: string): boolean {
  try {
    const { hostname } = new URL(url);
    return (ALLOWED_AGENT_IMAGE_HOSTNAMES as readonly string[]).includes(hostname);
  } catch {
    return false;
  }
}

export function getAgentPhotoSrcForAvatar(photo?: string): string | null {
  const trimmed = photo?.trim() ?? '';
  if (!trimmed) return null;
  if (trimmed === DEFAULT_AGENT_PROFILE_PIC_PATH) return null;
  if (trimmed.startsWith('/')) return trimmed;
  return isAllowedImageDomain(trimmed) ? trimmed : null;
}
